"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Filter = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@coreui/react");
const Replay_1 = __importDefault(require("@material-ui/icons/Replay"));
const react_2 = require("react");
function Filter({ column, table, }) {
    const firstValue = table
        .getPreFilteredRowModel()
        .flatRows[0]?.getValue(column.id);
    const columnFilterValue = column.getFilterValue();
    const sortedUniqueValues = (0, react_2.useMemo)(() => typeof firstValue === 'number'
        ? []
        : Array.from(column.getFacetedUniqueValues().keys()).sort(), [column.getFacetedUniqueValues()]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("datalist", { id: column.id + 'list', children: sortedUniqueValues.slice(0, 5000).map((value) => ((0, jsx_runtime_1.jsx)("option", { value: value }, value))) }), (0, jsx_runtime_1.jsxs)("div", { className: "input-and-reset", children: [(0, jsx_runtime_1.jsx)(DebouncedInput, { type: "text", value: columnFilterValue ? String(columnFilterValue) : '', onChange: (value) => column.setFilterValue(value), placeholder: "Type to filter..." }), (0, jsx_runtime_1.jsx)("div", { onClick: () => {
                            column.setFilterValue('');
                        }, role: "button", tabIndex: 0, onKeyDown: (e) => {
                            if (e.key === 'Enter') {
                                column.setFilterValue('');
                            }
                        }, className: "reset-icon", children: (0, jsx_runtime_1.jsx)(Replay_1.default, {}) })] })] }));
}
exports.Filter = Filter;
// A debounced input react component
function DebouncedInput({ value: initialValue, onChange, debounce = 500, }) {
    const [value, setValue] = (0, react_2.useState)(initialValue);
    (0, react_2.useEffect)(() => {
        setValue(initialValue);
    }, [initialValue]);
    (0, react_2.useEffect)(() => {
        const timeout = setTimeout(() => {
            onChange(value);
        }, debounce);
        return () => clearTimeout(timeout);
    }, [value]);
    return ((0, jsx_runtime_1.jsx)(react_1.CFormInput, { placeholder: "Type to filter...", value: value, onChange: (e) => setValue(e.target.value), type: "text", "data-testid": "filter-input" }));
}
